// FP 간트 — 바 라벨/툴팁 공용 포맷터
//
// OrderGantt에서 화면 로컬 함수로 시작했다가 ResourceGantt(2번째 화면)가 같은 포맷을 그대로 쓰게 돼
// 공용으로 승격했다(§A-3c의 "2번째 화면 착수 시 승격" 기준). AdjustmentGantt도 같은 툴팁을 쓴다.

import numberUtil from "@plannel/utils/number-util";

// old getFormattedQty(qty, itemUom) — "1,234 (EA)".
export const formatQty = (qty, uom) => {
  if (qty == null) return "";
  const formatted = numberUtil.formatNumber(Number(qty));
  return uom ? `${formatted} (${uom})` : `${formatted}`;
};

// 백엔드 Types.toTimeString이 "시/분/초"를 "h/m/s" 문자열로 내려준다(ActivityDetailDto.tsDiff 등) —
// old timeToString과 동일하게 단위 라벨을 붙여 사람이 읽는 형태로 만든다.
export const formatTimeDiff = (value, t) => {
  if (!value) return "";
  const [hour = "0", min = "0", sec = "0"] = String(value).split("/");
  return `${hour}${t("FP_HOUR")} ${min}${t("FP_MINUTES")} ${sec}${t("FP_SECOND")}`;
};

// 코드/명칭을 한 줄로 합쳐 보여줄 때 — "ITEM#01 (완제품)". 명칭이 없으면 코드만 돌려준다.
// 상세 조회(ActivityDetailDto)는 **코드와 명칭을 각각** 내려주므로(2026-08-25 백엔드 정리, 그전에는
// 쿼리에서 합쳐 보냈다) 한 줄로 쓸 곳은 이 함수를, 두 줄로 나눠 그릴 곳은
// `GanttDetailRows`의 `subValue`를 쓴다.
export const formatCodeName = (code, name) => {
  const cd = code ?? "";
  return name ? `${cd} (${name})` : `${cd}`;
};
